import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';

interface IProps {
  operations: Operation[],
  operationsSelected: string[]
}

const S3Plugin = React.lazy(() => importFromS3('settings'));

export const SettingsPluginContainer: React.FC<IProps> = ({ operations, operationsSelected }: IProps) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags['web.settings.module-federation'];

  const SettingsPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('settings/Settings'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  return <SettingsPlugin
    operations={operations}
    operationsSelected={operationsSelected}
  />;
};
